import Grid from "@material-ui/core/Grid";
import { Link } from "gatsby";
import React from "react";
import RedLine from "../../components/RedLine";
import "./ServicesList.scss";
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const ServicesList = (props) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <div id="service" className={props.customClass}>
        {props.ServicesviewTitle ? <RedLine /> : ""}
        <Grid
          className="services-container"
          justify="space-around"
          container
          spacing={isSmall ? 0 : 3}
        >
          <Grid item className="services1-rsp services-content" sm={4} xs={12}>
            {props.servicesColumn1 &&
              props.servicesColumn1.data.map((element, index) => {
                const link = element.service
                  .toLowerCase()
                  .replace(/& /g, "")
                  .replace(/ /g, "-");
                const url = window.location.href.toLowerCase();
                if (url.includes(link)) {
                  return (
                    <Link
                      className="services-link"
                      to={element.link}
                      key={index}
                    >
                      <p className="services-active">{element.service}</p>
                    </Link>
                  );
                } else {
                  return (
                    <Link
                      className="services-link"
                      to={element.link}
                      key={index}
                    >
                      <p className="services">{element.service}</p>
                    </Link>
                  );
                }
              })}
            {props.servicesColumn1 && props.servicesColumn1.title && (
              <div className="service-title">{props.servicesColumn1.title}</div>
            )}
          </Grid>
          <Grid item className="services2-rsp services-content" sm={4} xs={12}>
            {props.servicesColumn2 &&
              props.servicesColumn2.data.map((element, index) => {
                const link = element.service.toLowerCase().replace(/ /g, "-");
                const url = window.location.href.toLowerCase();
                if (url.includes(link)) {
                  return (
                    <Link
                      className="services-link"
                      to={element.link}
                      key={index}
                    >
                      <p className="services-active">{element.service}</p>
                    </Link>
                  );
                } else {
                  return (
                    <Link
                      className="services-link"
                      to={element.link}
                      key={index}
                    >
                      <p className="services">{element.service}</p>
                    </Link>
                  );
                }
              })}
            {props.servicesColumn2 && props.servicesColumn2.title && (
              <div className="service-title">{props.servicesColumn2.title}</div>
            )}
          </Grid>
          <Grid item className="services3-rsp services-content" sm={4} xs={12}>
            {props.servicesColumn3 &&
              props.servicesColumn3.data.map((element, index) => {
                const link = element.service.toLowerCase().replace(/ /g, "-");
                const url = window.location.href.toLowerCase();
                if (url.includes(link)) {
                  return (
                    <Link
                      className="services-link"
                      to={element.link}
                      key={index}
                    >
                      <p className="services-active">{element.service}</p>
                    </Link>
                  );
                } else {
                  return (
                    <Link
                      className="services-link"
                      to={element.link}
                      key={index}
                    >
                      <p className="services">{element.service}</p>
                    </Link>
                  );
                }
              })}
            {props.servicesColumn3 && props.servicesColumn3.title && (
              <div className="service-title">{props.servicesColumn3.title}</div>
            )}
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default ServicesList;
